import { Button, IconButton, styled } from '@mui/material';

export const NavBarButton = styled(Button)({
   borderRadius: '8px',
   backgroundColor: '#F8FAFC',
   boxShadow: '0px 1px 1px 0px rgba(0, 0, 0, 0.06), 0px 1px 2px 0px rgba(0, 0, 0, 0.10)',
   padding: '10px 15px 8px 15px',
   color: '#404040',
   textTransform: 'none',
});

export const ControlPanelNavbarButton = styled(Button)({
   borderRadius: '8px',
   backgroundColor: 'transparent',
   padding: '10px 15px 8px 15px',
   color: '#404040',
   textTransform: 'none',
   '&:hover': {
      borderRadius: '8px',
   },
});

export const SelectCountryButton = styled(Button)({
   height: '48px',
   backgroundColor: 'transparent',
   padding: '5px 16px 8px 16px',
   '&:hover': {
      backgroundColor: 'transparent',
   },
});

export const GoogleOutlinedButton = styled(Button)({
   width: '100%',
   display: 'flex',

   gap: '6px',
   borderRadius: '8px',
   border: '1px solid #C9C9C9',
   backgroundColor: 'white',
   padding: '2px 10px',
   color: '#4E4E4E',
   height: '40px',
});

export const BlueOutlinedButton = styled(Button)({
   width: '100%',
   display: 'flex',

   gap: '6px',
   borderRadius: '8px',
   border: '2px solid #151686',
   backgroundColor: '151686',
   padding: '2px 10px',
   color: '#151686',
   height: '40px',

});

export const LoginMIDButton = styled(Button)({
   width: '100%',
   display: 'flex',

   gap: '6px',
   borderRadius: '8px',
   // border: '2px solid #151686',
   backgroundColor: '#0057FF',
   padding: '16px 0px',
   color: '#fff',
   height: '40px',
   boxShadow: '0px 8px 24px 0px rgba(11, 75, 149, 0.20)',
   textTransform: 'none',
   // transition: 'background-color 0.3s ease, box-shadow 0.3s ease',

   '&:hover': {
      backgroundColor: '#0057FF', // Màu sáng nhẹ hơn gốc
      // boxShadow: '0px 10px 28px rgba(11, 75, 149, 0.25)',
   },
});

export const LoginGoogleButton = styled(Button)({
   width: '100%',
   display: 'flex',

   gap: '6px',
   borderRadius: '8px',
   // border: '1px solid #C9C9C9',
   backgroundColor: 'white',
   padding: '16px 0px',
   height: '40px',
   border: '1px solid #C9C9C9',
   boxShadow: '0px 8px 24px 0px rgba(11, 75, 149, 0.20)',
   // textTransform: 'none', 
   // '&:hover': {
   //    backgroundColor: 'white', 
   //    boxShadow: '0px 8px 24px 0px rgba(11, 75, 149, 0.20)', 
   // },
});

export const LoginVNEIDButton = styled(Button)({
   width: '100%',
   display: 'flex',

   gap: '6px',
   borderRadius: '8px',
   // border: '1px solid #C9C9C9',
   backgroundColor: '#d92d20',
   padding: '16px 0px',
   height: '40px',
   border: '1px solid #C9C9C9',
   boxShadow: '0px 8px 24px 0px rgba(11, 75, 149, 0.20)',
   color: '#fff',
   '&:hover': {
      backgroundColor: '#DC3546', // Màu sáng nhẹ hơn gốc
      // boxShadow: '0px 10px 28px rgba(11, 75, 149, 0.25)',
   },
});

export const PrimaryButtonFullWidth = styled(Button)({
   height: "40px",
   borderRadius: '8px',
   background: '#0057FF',
   boxShadow: '0px 8px 24px 0px rgba(11, 75, 149, 0.20)',
   width: '100%',
   padding: '15px',
   color: '#FFF',
   '&:hover': {
      color: '#FFF',
      background: '#0057FF',
   },
   '&:disabled': {
      opacity: 0.5,
      color: '#FFF',
   },
});

export const WhiteButtonFullWidth = styled(Button)({
   borderRadius: '8px',
   background: 'white',
   boxShadow: '0px 8px 24px 0px rgba(11, 75, 149, 0.20)',
   width: '100%',
   padding: '15px',
   color: '#D00D00',
   height: '40px',
   border: '1px solid #D00D00',
});


export const PrimaryButton = styled(Button)({
   borderRadius: '8px',
   background: '#0057FF',
   boxShadow: '0px 8px 24px 0px rgba(11, 75, 149, 0.20)',
   padding: '15px',
   color: '#FFF',
   '&:hover': {
      color: '#FFF',
      background: '#0057FF',
   },
   '&:disabled': {
      opacity: 0.5,
      color: '#FFF',
   },
});

export const DrawerCollapseIconButton = styled(IconButton)({
   transition: '0.3s',
   borderRadius: '9999px',
});

// export const DrawerCollapseIconButton = styled(IconButton)({
//    transition: '0.3s',
//    borderRadius: '9999px',
//    backgroundColor: '#EFF6FF',
//    boxShadow: '2px 2px 8px 0px rgba(0, 0, 0, 0.10)',
//    '&:hover': {
//       backgroundColor: '#3B82F6',
//       '& path': {
//          fill: '#FFF',
//       },
//    },
// });

export const NotificationIconButton = styled(IconButton)({
   transition: '0.3s',
   borderRadius: '9999px',
   border: '1px solid #404040',
   '&:hover': {
      backgroundColor: '#FFF',
      border: '1px solid #3B82F6',
      '& path': {
         fill: '#3B82F6',
      },
   },
   '&.active': {
      backgroundColor: '#FFF',
      border: '1px solid #3B82F6',
      '& path': {
         fill: '#3B82F6',
      },
   },
});

export const GrayIconButton = styled(IconButton)({
   transition: '0.3s',
   borderRadius: '9999px',
   backgroundColor: '#EFEFEF',
   width: "36px",
   height: "36px",
   '&:hover': {
      backgroundColor: '#EFEFEF',
   },
});

export const HambugerIconButton = styled(IconButton)({
   transition: '0.3s',
   borderRadius: '9999px',
   color: '#3B82F6',
   backgroundColor: 'transparent',
   '&:hover': {
      backgroundColor: '#EFEFEF',
   },
});

export const WhiteButton = styled(IconButton, {
   shouldForwardProp: (prop) => prop !== "open",
})(({ open }) => ({
   transition: "0.3s",
   borderRadius: "9999px",
   backgroundColor: open ? "#DBEAFE" : "#fff",
   color: open ? "#3B82F6" : "",

   "&:hover": {
      backgroundColor: "#DBEAFE",
      color: "#3B82F6",
   },
}));

export const GrayButton = styled(IconButton, {
   shouldForwardProp: (prop) => prop !== "open",
})(({ open }) => ({
   transition: "0.3s",
   borderRadius: "9999px",
   backgroundColor: "#f3f4f6",
   color: "#f3f4f6",

   "&:hover": {
      backgroundColor: "#f3f4f6",
      color: "#3B82F6",
   },
}));

export const TransparentButton = styled(IconButton, {
   shouldForwardProp: (prop) => prop !== "open",
})(({ open }) => ({
   transition: "0.3s",
   borderRadius: "9999px",
   backgroundColor: open ? "#DBEAFE" : "#fff",
   color: open ? "#3B82F6" : "",

   "&:hover": {
      backgroundColor: "#fff",
      //  color: "#3B82F6",
   },
}));

// export const WhiteButton = styled(IconButton)({
//    transition: '0.3s',
//    borderRadius: '9999px',
//    // color: '#3B82F6',
//    backgroundColor: '#fff',
//    '&:hover': {
//       backgroundColor: '#DBEAFE',
//    },
// });

export const SuccessCircleButton = styled(IconButton)({
   transition: '0.3s',
   borderRadius: '9999px',
   backgroundColor: '#CCFBF1',
   '.MuiSvgIcon-root': {
      fontSize: '18px',
   },
   '& path': {
      fill: '#14B8A6',
   },
   '&:hover': {
      backgroundColor: '#CCFBF1',
      '& path': {
         fill: '#14B8A6',
      },
   },
});

export const ErrorCircleButton = styled(IconButton)({
   transition: '0.3s',
   borderRadius: '9999px',
   backgroundColor: '#FEE2E2',
   '.MuiSvgIcon-root': {
      fontSize: '18px',
   },
   '& path': {
      fill: '#EF4444',
   },
   '&:hover': {
      backgroundColor: '#FEE2E2',
      '& path': {
         fill: '#EF4444',
      },
   },
});

export const InfoCircleButton = styled(IconButton)({
   transition: '0.3s',
   borderRadius: '9999px',
   backgroundColor: '#DBEAFE',
   '.MuiSvgIcon-root': {
      fontSize: '18px',
   },
   '& path': {
      fill: '#3B82F6',
   },
   '&:hover': {
      backgroundColor: '#DBEAFE',
      '& path': {
         fill: '#3B82F6',
      },
   },
});

export const ErrorSecondaryButton = styled(Button)({
   width: 'fit-content',
   transition: '0.3s',
   borderRadius: '8px',
   backgroundColor: '#FEE2E2',
   color: '#EF4444',
   '& path': {
      fill: '#EF4444',
   },
   '&:hover': {
      backgroundColor: '#FEE2E2',
      '& path': {
         fill: '#EF4444',
      },
   },
});

export const ControlpanelPrimaryButton = styled(Button)({
   height: '40px',
   fontSize: '14px',
   display: 'flex',
   alignItems: 'center',
   gap: '3px',
   backgroundColor: '#0057FF',
   color: '#FFF',
   padding: '10px 8px',
   borderRadius: '8px',
   '.MuiSvgIcon-root': {
      fontSize: '16px',
   },

   '&:hover': {
      backgroundColor: '#3B82F6',
   },
   '&:disabled': {
      color: '#FFF',
      backgroundColor: '#93C5FD',
   },
   '@media (max-width: 768px)': {
      fontSize: '12px',

      '.MuiSvgIcon-root': {
         fontSize: '14px !important',
      },
   },

   '@media (max-width: 1440px)': {
      fontSize: '12px',

      '.MuiSvgIcon-root': {
         fontSize: '14px !important',
      },
   },
});

export const ControlpanelPrimaryButtonV2 = styled(Button)({
   height: '40px',
   fontSize: '14px',
   display: 'flex',
   alignItems: 'center',
   gap: '3px',
   backgroundColor: '#ffffff',
   color: '#0057FF',
   padding: '10px 8px',
   borderRadius: '8px',
   border: '1.5px solid #0057FF',
   '.MuiSvgIcon-root': {
      fontSize: '16px',
   },

   '&:hover': {
      backgroundColor: '#E0E7FF',
   },
   '&:disabled': {
      color: '#FFF',
      backgroundColor: '#93C5FD',
   },
   '@media (max-width: 768px)': {
      fontSize: '12px',

      '.MuiSvgIcon-root': {
         fontSize: '14px !important',
      },
   },

   '@media (max-width: 1440px)': {
      fontSize: '12px',

      '.MuiSvgIcon-root': {
         fontSize: '14px !important',
      },
   },
});

export const ControlpanelPrimary3thButton = styled(Button)({
   height: '40px',
   fontSize: '14px',
   display: 'flex',
   alignItems: 'center',
   gap: '3px',
   borderRadius: '8px',
   backgroundColor: '#FFF',
   color: '#3B82F6',
   padding: '10px 8px',
   border: '2px solid #3B82F6',
   '.MuiSvgIcon-root': {
      fontSize: '16px',
   },

   '&:hover': {
      backgroundColor: '#FFF',
   },
   // "&:disabled": {
   //     color: "#FFF",
   //     backgroundColor: "#93C5FD"
   // },
   '@media (max-width: 768px)': {
      fontSize: '12px',

      '.MuiSvgIcon-root': {
         fontSize: '14px !important',
      },
   },
});

export const ControlpanelPrimaryButtonNoPadding = styled(Button)({
   height: '40px',
   fontSize: '14px',
   display: 'flex',
   alignItems: 'center',
   gap: '3px',
   borderRadius: '8px',
   backgroundColor: '#3B82F6',
   color: '#FFF',
   padding: '10px 0px',
   minWidth: '40px',

   '.MuiSvgIcon-root': {
      fontSize: '16px',
   },

   '&:hover': {
      backgroundColor: '#3B82F6',
   },
   '&:disabled': {
      color: '#FFF',
      backgroundColor: '#93C5FD',
   },
   '@media (max-width: 768px)': {
      fontSize: '12px',

      '.MuiSvgIcon-root': {
         fontSize: '14px !important',
      },
   },
});

export const ControlpanelInfo2thButton = styled(Button)({
   height: '40px',
   fontSize: '14px',
   display: 'flex',
   alignItems: 'center',
   gap: '3px',
   borderRadius: '8px',
   backgroundColor: '#DBEAFE',
   color: '#3B82F6',
   padding: '10px 8px',

   '.MuiSvgIcon-root': {
      fontSize: '16px',
   },

   '&:hover': {
      backgroundColor: '#DBEAFE',
   },
   '&:disabled': {
      color: '#FFF',
      backgroundColor: '#93C5FD',
   },
   '@media (max-width: 768px)': {
      fontSize: '12px',

      '.MuiSvgIcon-root': {
         fontSize: '14px !important',
      },
   },

   '@media (max-width: 1440px)': {
      fontSize: '12px',

      '.MuiSvgIcon-root': {
         fontSize: '14px !important',
      },
   },
});

export const ControlpanelErrorButton = styled(Button)({
   height: '40px',
   fontSize: '14px',
   display: 'flex',
   alignItems: 'center',
   gap: '3px',
   borderRadius: '8px',
   backgroundColor: '#D00D00',
   color: '#FFF',
   padding: '10px 8px',

   '.MuiSvgIcon-root': {
      fontSize: '16px',
   },

   '&:hover': {
      backgroundColor: '#D00D00',
   },

   '&.Mui-disabled': {
      opacity: 0.5,
      pointerEvents: 'all',
      cursor: 'not-allowed',
      color: '#FFF',
   },
   '@media (max-width: 768px)': {
      fontSize: '12px',

      '.MuiSvgIcon-root': {
         fontSize: '14px !important',
      },
   },
});

export const ControlpanelError3thButton = styled(Button)({
   height: '40px',
   fontSize: '14px',
   display: 'flex',
   alignItems: 'center',
   gap: '3px',
   borderRadius: '8px',
   backgroundColor: '#FFF',
   color: '#EF4444',
   border: '2px solid #EF4444',
   padding: '10px 8px',

   '.MuiSvgIcon-root': {
      fontSize: '16px',
   },

   '&:hover': {
      backgroundColor: '#FFF',
   },

   '&.Mui-disabled': {
      opacity: 0.5,
      pointerEvents: 'all',
      cursor: 'not-allowed',
      color: '#FFF',
   },
   '@media (max-width: 768px)': {
      fontSize: '12px',

      '.MuiSvgIcon-root': {
         fontSize: '14px !important',
      },
   },
});

export const ControlpanelWarningButton = styled(Button)({
   height: '40px',
   fontSize: '14px',
   display: 'flex',
   alignItems: 'center',
   gap: '3px',
   borderRadius: '8px',
   backgroundColor: '#EAB308',
   color: '#FFF',
   padding: '10px 8px',

   '.MuiSvgIcon-root': {
      fontSize: '16px',
   },

   '&:hover': {
      backgroundColor: '#EAB308',
   },
   '@media (max-width: 768px)': {
      fontSize: '12px',

      '.MuiSvgIcon-root': {
         fontSize: '14px !important',
      },
   },
});

export const ControlpanelWarning2thButton = styled(Button)({
   height: '40px',
   fontSize: '14px',
   display: 'flex',
   alignItems: 'center',
   gap: '3px',
   borderRadius: '8px',
   backgroundColor: '#FEF9C3',
   color: '#EAB308',
   padding: '10px 8px',

   '.MuiSvgIcon-root': {
      fontSize: '16px',
   },

   '&:hover': {
      backgroundColor: '#FEF9C3',
   },
   '@media (max-width: 768px)': {
      fontSize: '12px',

      '.MuiSvgIcon-root': {
         fontSize: '14px !important',
      },
   },

   '@media (max-width: 1440px)': {
      fontSize: '12px',

      '.MuiSvgIcon-root': {
         fontSize: '14px !important',
      },
   },
});

export const ControlpanelSuccessButton = styled(Button)({
   height: '40px',
   fontSize: '14px',
   display: 'flex',
   alignItems: 'center',
   gap: '3px',
   borderRadius: '8px',
   backgroundColor: '#058900',
   color: '#FFF',
   padding: '10px 8px',

   '.MuiSvgIcon-root': {
      fontSize: '16px',
   },

   '&:hover': {
      backgroundColor: '#058900',
   },
   '@media (max-width: 768px)': {
      fontSize: '12px',

      '.MuiSvgIcon-root': {
         fontSize: '14px !important',
      },
   },
});

export const ControlpanelSuccess2thButton = styled(Button)({
   height: '40px',
   fontSize: '14px',
   display: 'flex',
   alignItems: 'center',
   gap: '3px',
   borderRadius: '8px',
   backgroundColor: '#CCFBF1',
   color: '#14B8A6',
   padding: '10px 8px',

   '.MuiSvgIcon-root': {
      fontSize: '16px',
   },

   '&:hover': {
      backgroundColor: '#CCFBF1',
   },
   '@media (max-width: 768px)': {
      fontSize: '12px',

      '.MuiSvgIcon-root': {
         fontSize: '14px !important',
      },
   },
});

export const ControlpanelSuccess3thButton = styled(Button)({
   height: '40px',
   fontSize: '14px',
   display: 'flex',
   alignItems: 'center',
   gap: '3px',
   borderRadius: '8px',
   backgroundColor: '#F5F8FF',
   color: '#0057FF',
   border: '#DBE8FF 1px solid',
   padding: '10px 8px',

   '.MuiSvgIcon-root': {
      fontSize: '16px',
   },

   '&:hover': {
      backgroundColor: '#F5F8FF',
   },
   '@media (max-width: 768px)': {
      fontSize: '12px',

      '.MuiSvgIcon-root': {
         fontSize: '14px !important',
      },
   },
});

export const ControlpanelRefreshButton = styled(Button)({
   height: '40px',
   fontSize: '14px',
   display: 'flex',
   alignItems: 'center',
   gap: '3px',
   borderRadius: '8px',
   border: '1px solid #DBE8FF',
   backgroundColor: '#F5F8FF',
   color: '#0057FF',
   padding: '10px 8px',

   '.MuiSvgIcon-root': {
      fontSize: '16px',
   },
   '@media (max-width: 768px)': {
      fontSize: '12px',

      '.MuiSvgIcon-root': {
         fontSize: '14px !important',
      },
   },
});

export const ControlpanelSecondaryButton = styled(Button)({
   height: '40px',
   fontSize: '14px',
   display: 'flex',
   alignItems: 'center',
   gap: '3px',
   borderRadius: '8px',
   backgroundColor: '#FFFFFF',
   border: '1px solid #bebebe',
   color: '#1F2937',
   padding: '10px 8px',

   '.MuiSvgIcon-root': {
      fontSize: '16px',
   },
   '&.Mui-disabled': {
      opacity: 0.7,
      color: '#1F2937',
   },
   '&:hover': {
      backgroundColor: '#F3F4F6',
   },
   '@media (max-width: 768px)': {
      fontSize: '12px',

      '.MuiSvgIcon-root': {
         fontSize: '14px !important',
      },
   },
});

export const ControlpanelCancelButton = styled(Button)({
   height: '40px',
   fontSize: '14px',
   display: 'flex',
   alignItems: 'center',
   gap: '3px',
   borderRadius: '8px',
   backgroundColor: '#FFFFFF',
   color: '#1F2937',
   border: '1px solid #E5E7EB',
   padding: '10px 8px',

   '.MuiSvgIcon-root': {
      fontSize: '16px',
   },
   '&.Mui-disabled': {
      opacity: 0.7,
      color: '#1F2937',
   },
   '&:hover': {
      backgroundColor: '#F3F4F6',
   },
   '@media (max-width: 768px)': {
      fontSize: '12px',

      '.MuiSvgIcon-root': {
         fontSize: '14px !important',
      },
   },
});

export const ControlpanelDeleteButton = styled(Button)({
   height: '40px',
   fontSize: '14px',
   display: 'flex',
   alignItems: 'center',
   gap: '3px',
   borderRadius: '8px',
   backgroundColor: '#FFFFFF',
   color: '#D00D00',
   border: '1px solid #D00D00',
   padding: '10px 8px',

   '.MuiSvgIcon-root': {
      fontSize: '16px',
   },
   '&.Mui-disabled': {
      opacity: 0.7,
      color: '#D00D00',
   },
   '&:hover': {
      backgroundColor: '#FAE7E6',
   },
   '@media (max-width: 768px)': {
      fontSize: '12px',

      '.MuiSvgIcon-root': {
         fontSize: '14px !important',
      },
   },
});

export const ControlpanelSecondaryButtonV2 = styled(Button)({
   height: '40px',
   fontSize: '14px',
   display: 'flex',
   alignItems: 'center',
   gap: '3px',
   border: "1px solid #E5E7EB",
   borderRadius: '8px',
   backgroundColor: '#FFFFFF',
   color: '#6B7280',
   padding: '10px 8px',

   '.MuiSvgIcon-root': {
      fontSize: '16px',
   },
   '&.Mui-disabled': {
      opacity: 0.7,
      color: '#FFF',
   },
   '&:hover': {
      backgroundColor: '#FFFFFF',
   },
   '@media (max-width: 768px)': {
      fontSize: '12px',

      '.MuiSvgIcon-root': {
         fontSize: '14px !important',
      },
   },
});

export const ControlpanelRestartButton = styled(Button)({
   height: '40px',
   fontSize: '14px',
   display: 'flex',
   alignItems: 'center',
   gap: '3px',
   borderRadius: '8px',
   border:"1px solid #E5E7EB",
   backgroundColor: '#FFFFFF',
   color: '#6B7280',
   padding: '10px 8px',

   '.MuiSvgIcon-root': {
      fontSize: '16px',
   },
   '&.Mui-disabled': {
      opacity: 0.7,
      color: '#6B7280',
   },
   // '&:hover': {
   //    backgroundColor: '#6B7280',
   // },
   '@media (max-width: 768px)': {
      fontSize: '12px',

      '.MuiSvgIcon-root': {
         fontSize: '14px !important',
      },
   },
});

export const ControlpanelSecondary2thButton = styled(Button)({
   height: '40px',
   fontSize: '14px',
   display: 'flex',
   alignItems: 'center',
   gap: '3px',
   borderRadius: '8px',
   backgroundColor: '#F3F4F6',
   color: '#1F2937',
   padding: '10px 8px',

   '.MuiSvgIcon-root': {
      fontSize: '16px',
   },

   '&:hover': {
      backgroundColor: '#F3F4F6',
   },
   '@media (max-width: 768px)': {
      fontSize: '12px',

      '.MuiSvgIcon-root': {
         fontSize: '14px !important',
      },
   },
});

export const ControlpanelPurpleButton = styled(Button)({
   height: '40px',
   fontSize: '14px',
   display: 'flex',
   alignItems: 'center',
   gap: '3px',
   borderRadius: '8px',
   backgroundColor: '#8B5CF6',
   color: '#FFF',
   padding: '10px 8px',

   '.MuiSvgIcon-root': {
      fontSize: '16px',
   },

   '&:hover': {
      backgroundColor: '#8B5CF6',
   },
   '@media (max-width: 768px)': {
      fontSize: '12px',

      '.MuiSvgIcon-root': {
         fontSize: '14px !important',
      },
   },
});

export const ControlpanelPurple2thButton = styled(Button)({
   height: '40px',
   fontSize: '14px',
   display: 'flex',
   alignItems: 'center',
   gap: '3px',
   borderRadius: '8px',
   backgroundColor: '#EDE9FE',
   color: '#C084FC',
   padding: '10px 8px',

   '.MuiSvgIcon-root': {
      fontSize: '16px',
   },

   '&:hover': {
      backgroundColor: '#EDE9FE',
   },
   '@media (max-width: 768px)': {
      fontSize: '12px',

      '.MuiSvgIcon-root': {
         fontSize: '14px !important',
      },
   },
});

export const ControlpanelGrayButton = styled(Button)({
   height: '40px',
   fontSize: '14px',
   display: 'flex',
   alignItems: 'center',
   gap: '3px',
   borderRadius: '8px',
   backgroundColor: '#A3A3A3',
   color: '#FFF',
   padding: '10px 8px',

   '.MuiSvgIcon-root': {
      fontSize: '16px',
   },

   '&:hover': {
      backgroundColor: '#A3A3A3',
   },
   '@media (max-width: 768px)': {
      fontSize: '12px',

      '.MuiSvgIcon-root': {
         fontSize: '14px !important',
      },
   },
});

export const ControlpanelGrayBorderWhiteButton = styled(Button)({
   height: '40px',
   fontSize: '14px',
   display: 'flex',
   alignItems: 'center',
   gap: '3px',
   border: '1px solid #E5E7EB',
   borderRadius: '8px',
   backgroundColor: '#FFF',
   color: '#6B7280',
   padding: '10px 8px',

   '.MuiSvgIcon-root': {
      fontSize: '16px',
   },

   '&:hover': {
      backgroundColor: '#FFF',
   },
   '@media (max-width: 768px)': {
      fontSize: '12px',

      '.MuiSvgIcon-root': {
         fontSize: '14px !important',
      },
   },
});
